<!--  -->
<template>
    <div>
        <div class="Navigation">
            <div class="contant clearfix">
                <span class="fl logo">MTMONE</span>
                <ul>
                    <li @click="nav(1)" :class="{act:show==1}">首页</li>
                    <li @click="nav(2)" :class="{act:show==2}">共享面料库</li>
                    <li @click="nav(3)" :class="{act:show==3}">潮流版型库</li>
                    <li @click="nav(4)" :class="{act:show==4}">海量智能制造商</li>
                    <li @click="nav(5)" :class="{act:show==5}">定制精品</li>
                    <li @click="nav(6)" :class="{act:show==6}">加入我们</li>
                    <li @click="nav(7)" :class="{act:show==7}">关于</li>
                    <!-- <li @click="nav(8)" :class="{act:show==8}">合作伙伴</li>
                <li @click="nav(9)" :class="{act:show==9}">联系我们</li> -->
                </ul>
                <div class="login">
                    <span>登录:</span>
                    <span class="store" @click="Mtm()">店铺</span>
                    <span class="sheng" @click="bossMtm()">生产制造商</span>
                </div>
            </div>
        </div>
        <div class="banner" id="page1">
            <Carousel v-model="banner" loop autoplay :autoplay-speed="5000">
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../assets/img/banner1.png" />
                        <div class="register1">
                            <span @click="register()">店铺注册</span>
                            <span @click="join()">生产制造商加盟</span>
                        </div>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../assets/img/banner2.png" />
                        <span class="register2" @click="register()">免费注册</span>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../assets/img/banner3.png" />
                        <span class="register3" @click="join()">免费注册</span>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../assets/img/banner4.png" />
                    </div>
                </CarouselItem>
            </Carousel>
        </div>
        <div class="one" id="page2">
            <div class="contant">
                <div class="title title1">
                    <h3>共享面料库</h3>
                    <span></span>
                </div>
                <div class="cont">
                    在平台的数字展厅中轻松触及到超过30,000多种奢华及卓越质感的西装和衬衣面料。

                    优雅或休闲，作为经典的传承或者色彩缤纷的宣言，所有的面料均来自全球专业的西装和衬衣面料制造商，自定义以及匹配不同的品味和场合。
                </div>
                <ul>
                    <li style="margin-right:0.2rem">
                        <img src="../assets/img/mian-a.png" />
                        <p>西装面料</p>
                    </li>
                    <li>
                        <img src="../assets/img/mian-b.png" />
                        <p>衬衫面料</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="two" id="page3">
            <div class="title title1">
                <h3>潮流版型库</h3>
                <span></span>
            </div>
            <div class="clearfix chao">
                <img src="../assets/img/ban.png" />
                <div class="cont">
                    在平台中轻松浏览和管理超过10,000种潮流和经典的版型库。

                    使用便捷直观，快速调取，使用标准化格式避免遗漏信息。

                    能调取共享质感面料库中的信息，并添加和创建在版型中，呈现虚拟视觉效果。

                    确保版型能准确直达供应链中的生产制造商，避免分享错误的信息。
                </div>
            </div>
        </div>
        <div class="three" id="page4">
            <div class="title title1">
                <h3>海量智能制造商</h3>
                <span></span>
            </div>
            <div class="cont">
                联通50多家智能高级定制服装生产商，帮助生产商打造符合自身特色的高级定制智能生产线。

                将设计、制造、物流和采购供应的要求进行链接，完善成熟整条“数字线”。 综合运用来自于设计、生产和管理中的数据，减少制造周期和成本；将制造过程全数字化，加强产品全生命周期的建模与先进分析工具，提升产品性能、工艺效率和企业绩效，最终实现全方位的成本降低。
            </div>
            <img src="../assets/img/map.png" />
        </div>
        <div class="four" id="page5">
            <div class="contant">
                <div class="title title1">
                    <h3>定制精品</h3>
                    <span></span>
                </div>
                <div class="clearfix choiceImg">
                    <img src="../assets/img/ding-a.png" />
                    <div class="fr cont">
                        <h3>西装套餐</h3>
                        <span class="border"></span>
                        <p>
                            敬请了解云数供应链由优质奢华面料制成的多场合适宜装着的西装套装，流行和极度舒适的完美结合。
                        </p>
                        <span class="btns">立即了解</span>
                    </div>
                </div>
                <div class="clearfix choiceImg">
                    <div class="fl cont cont1">
                        <h3>衬衫</h3>
                        <span class="border"></span>
                        <p>
                            奢华衬衫采用高支高密的精梳棉和其他舒适材质制成，不拘于正装和休闲服饰，版型多样，既有修身款也有经典款，敬请选购。
                        </p>
                        <span class="btns">立即了解</span>
                    </div>
                    <img src="../assets/img/ding-b.png" />
                </div>
            </div>
        </div>
        <div class="five" id="page6">
            <div class="title title1">
                <h3>加入我们</h3>
                <span></span>
            </div>
            <ul class="clearfix">
                <li class="Imga">
                    <h3>店铺注册</h3>
                    <p>智能AI量体/流行的版式和版型/共享高端面辅料资源/快速匹配供应链下单/实时看板</p>
                    <span>立即注册</span>
                </li>
                <li class="Imgb">
                    <h3>生产制造商加盟</h3>
                    <p>快速智能化产线改造/对接品牌和零售商/便捷接单/直通智能MES系统/共享高端面辅料资源</p>
                    <span>立即加盟</span>
                </li>
            </ul>
        </div>
        <div class="six" id="page7">
            <div class="title title1">
                <h3>关于</h3>
                <span></span>
            </div>
            <div class="cont">
                <p style="margin-bottom:0.3rem;">云数高定MTMONE供应链平台</p>

                <p>我们的旅程始于一个问题，如何才能更好赋能整个高级定制产业，</p>
                <p style="margin-bottom:0.3rem;">使之能更好得满足当代男士兼顾优雅和舒适的需求。</p>

                <p>创建于2018年的云数工场，</p>
                <p>一直致力于引领中国服装行业的数字化改造和智能化进程，</p>
                <p style="margin-bottom:0.3rem;">是为服装生产企业提供一体化智能工厂解决方案的软件服务商。</p>

                <p>但我们并不止步于此，</p>
                <p>虽然通过互联网发展的演进，能实现一定程度的个性化和规模化的结合，</p>
                <p>可是传统的高级定制资源的整合程度依然很低，</p>
                <p style="margin-bottom:0.3rem;">并不能及时得感知市场的变化，更好得引领中国定制品牌。</p>

                <p>历经四年，2021年云数工场蓄势而发，</p>
                <p>联通300家品牌/零售商和50家高级定制生产商,</p>
                <p>推出高定MTMONE供应链平台，希望通过我们的系统能力，</p>
                <p style="margin-bottom:0.6rem;">可以帮助整个高级定制产业链应对和消化市场的不确定性，拓展无限可能。</p>

                <p>在时代巨变的当今，我们不能置身局外。</p>
                <p>云数的目标是赋能全球高定产业链，从生产制造到品牌零售，</p>
                <p>让我们一起通过产品与人对话，与人连接，</p>
                <p>向这个世界交付我们的价值，并且获得回报。</p>
                <p>现在只是我们的开始......</p>
            </div>
        </div>
        <div class="seven" id="page8">
            <div class="title title1">
                <h3>合作伙伴</h3>
                <span></span>
            </div>
            <div class="clearfix Img">
                <img src="../assets/img/add-c.png" class="a" />
                <img src="../assets/img/coopera.png" class="b" />
            </div>
        </div>
        <!-- <div class="engin" id="page9">
            <div class="contant">
                <div class="foots clearfix">
                    <img src="../assets/img/erweima.png" />
                    <div class="fl centers one">
                        <p>公司：北京云数工场数据科技有限公司</p>
                        <p>地址：北京市门头沟区石龙经济开发区永安路20号3号楼A-6122</p>
                        <p>电话：0532-87670365</p>
                        <p>邮箱：lina.chen@yunnsoo.com</p>
                        <p>京ICP备18018291号</p>
                    </div>
                    <div class="fr contst one">
                        <p>公司：青岛云数章鱼纺织科技有限公司</p>
                        <p>地址：青岛市李沧区九水东路130号</p>
                        <p>电话：0532-87670365</p>
                        <p>邮箱：denise.wu@yunnsoo.com</p>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="engin" id="page9">
            <div class="contant">
                <div class="foots clearfix">
                    <div class="btn_mod fl">
                        <div class="text_box">
                            <p class="title">公司</p>
                            <p class="text hor" @click="nav(7)">关于</p>
                            <p class="text hor" @click="nav(6)">注册和加盟</p>
                            <p class="text hor">合作伙伴</p>
                            <p class="text hor">工作机会</p>
                        </div>
                        <div class="text_box">
                            <p class="title">服务</p>
                            <p class="text hor" @click="Mtm()">店铺登录</p>
                            <p class="text hor" @click="bossMtm()">生产制造商登录</p>
                            <p class="text hor" @click="nav(2)">共享面料库</p>
                            <p class="text hor" @click="nav(3)">潮流版型库</p>
                            <p class="text hor" @click="nav(4)">海量制造商</p>
                        </div>
                        <div class="text_box">
                            <p class="title">帮助</p>
                            <p class="text hor" @click="btnMtm('https://aax849ddj9.feishu.cn/docs/doccnFPSTlssoeXa04X7h8Q7Dvh')">平台规则</p>
                            <p class="text  hor">服务条款</p>
                            <p class="text hor" @click="btnMtm('https://aax849ddj9.feishu.cn/docs/doccnCgFgOp478yrhuKo826B2ah')">隐私政策</p>
                        </div>
                    </div>
                    <div class="btn_mod fr ">
                        <div class="text_box right_text">
                            <p class="title">联系我们</p>
                            <p class="text">公司：北京云数工场数据科技有限公司</p>
                            <p class="text">地址：北京市门头沟区石龙经济开发区永安路20号3号楼A</p>
                            <p class="text">邮箱：lina.chen@yunnsoo.com</p>
                            <hr class="text">
                            <p class="text">公司：青岛云数章鱼纺织科技有限公司</p>
                            <p class="text">地址：青岛市李沧区九水东路130号</p>
                            <p class="text">邮箱：denise.wu@yunnsoo.com</p>
                            <div class="photo_box fl">
                                <div class="photo photo_one fl">
                                    <img :src="require('../assets/img/btn_1.png')" alt="">
                                    <p class="ph_tit">业务咨询</p>
                                </div>
                                <div class="photo fl">
                                    <img :src="require('../assets/img/btn_2.png')" alt="">
                                    <p class="ph_tit2">公众号</p>
                                </div>
                                <div class="photo ph_iocn fl">
                                    <img class="iocn hor" :src="require('../assets/img/btn_3.png')" alt="" @click="btnMtm('https://www.zhihu.com/people/yun-shu-gong-chang')">
                                    <img class="iocn hor" :src="require('../assets/img/btn_4.png')" alt="" @click="btnMtm('https://www.douyin.com/user/MS4wLjABAAAAsvq3b0MTMkbHN2tUIJQJ6REG3jD2nJ-A8Sc22Bpj9wwIff4XfrE0WHcu5FGJgL6q?enter_from=recommend&enter_method=top_bar')">
                                    <img class="iocn hor" :src="require('../assets/img/btn_5.png')" alt="" @click="btnMtm('https://space.bilibili.com/2066619560')">
                                    <img class="iocn hor" :src="require('../assets/img/btn_6.png')" alt="" @click="btnMtm('https://weibo.com/u/7685199038')">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_bom">
                <p><a href="https://beian.miit.gov.cn" target="_blank" style="color: #75787f;">京ICP备18018291号</a></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: 1,
            banner: 0,
            scrollTop: 0,

        }
    },
    mounted() {
        this.nav(window.sessionStorage.getItem('id'))
        window.addEventListener('scroll', this.handleScroll, true)
        window.sessionStorage.setItem('id', '1')


    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    //调用函数
    methods: {
        // 保存滚动值，这是兼容的写法
        handleScroll() {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (this.scrollTop < 766) {
                this.show = 1;
                return
            }
            if (this.scrollTop >= 766 && this.scrollTop < 1283) {
                this.show = 2;
                return
            }
            if (this.scrollTop >= 1283 && this.scrollTop < 1859) {
                this.show = 3;
                return
            }
            if (this.scrollTop >= 1859 && this.scrollTop < 2763) {
                this.show = 4;
                return
            }
            if (this.scrollTop >= 2763 && this.scrollTop < 3717) {
                this.show = 5;
                return
            }
            if (this.scrollTop >= 3717 && this.scrollTop < 4747) {
                this.show = 6;
                return
            }
            if (this.scrollTop >= 4747) {
                this.show = 7;
                return
            }
            // if (this.scrollTop >= 5499 && this.scrollTop < 6920) {
            //   this.show =9;
            //   return
            // }
        },
        nav(type) {
            this.show = type;
            var PageId = document.querySelector('#page' + type)
            // 打印出对应页面与窗口的距离
            console.log(PageId.offsetTop)
            // 使用平滑属性，滑动到上方获取的距离
            // 下方我只设置了top，当然 你也可以加上 left 让他横向滑动
            // widow 根据浏览器滚动条，如果你是要在某个盒子里面产生滑动，记得修改
            window.scrollTo({
                'top': PageId.offsetTop,
                'behavior': 'smooth'
            })
        },
        Mtm() {
            window.open('http://s.mtmone.com/')
        },
        bossMtm() {
            window.open('http://mfg.mtmone.com/')
        },
        register() {
            this.$router.push('./joinShop')
        },
        join() {
            this.$router.push('./registerShop')
        },
        btnMtm(val) {
            window.open(val)
        }
    },
    //生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    //组件加载
    components: {

    },
}
</script>
<style scoped lang="scss">
/* @import url(); 引入css类 */
.Navigation {
  height: 0.9rem;
  width: 100%;
  background: rgba($color: #000000, $alpha: 0.4);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: #fff;
  z-index: 999999;
  .contant {
    width: 17rem;
  }
  .logo {
    font-size: 0.36rem;
    line-height: 0.9rem;
    font-weight: 800;
    display: block;
  }

  ul {
    float: left;
    margin-top: 0.3rem;

    li {
      cursor: pointer;
      height: 0.34rem;
      line-height: 0.34rem;
      font-size: 0.16rem;
      color: #fff;
      float: left;
      padding: 0 0.02rem;
      margin-left: 0.15rem;
      border-bottom: 0.02rem solid rgba($color: #999, $alpha: 0.1);
    }

    .act {
      border-bottom: 0.02rem solid rgba($color: #fff, $alpha: 0.6);
    }

    li:hover {
      border-bottom: 0.02rem solid rgba($color: #fff, $alpha: 0.6);
    }
  }

  .login {
    float: right;
    margin-top: 0.16rem;
    position: absolute;
    top: 0;
    right: 0;

    span {
      color: #fff;
      font-size: 0.14rem;
      display: block;
      float: left;
      height: 0.14rem;
      line-height: 0.14rem;
    }

    .store {
      background: url("../assets/img/login-b.png") no-repeat;
      background-size: 0.14rem 0.14rem;
      padding-left: 0.17rem;
      margin: 0 0.1rem;
      cursor: pointer;
    }

    .sheng {
      background: url("../assets/img/login-a.png") no-repeat;
      background-size: 0.14rem 0.14rem;
      padding-left: 0.17rem;
      cursor: pointer;
    }
  }
}

.banner {
  width: 100%;
  height: 10.8rem;
  // margin-bottom: 1.25rem;

  // background: #000000;
  .demo-carousel {
    height: 100%;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }

    .register1 {
      position: absolute;
      top: 7.5rem;
      margin-left: 4.6rem;
      color: #000000;
      font-size: 0.24rem;

      span {
        cursor: pointer;
        width: 2.16rem;
        height: 0.56rem;
        line-height: 0.56rem;
        display: block;
        margin-bottom: 0.33rem;
        background: rgba($color: #fff, $alpha: 0.75);
        text-align: center;
      }
    }

    .register2 {
      position: absolute;
      top: 7.7rem;
      margin-left: 4.6rem;
      display: block;
      height: 0.6rem;
      line-height: 0.6rem;
      border-bottom: 1px solid #fff;
      font-size: 0.24rem;
      color: #fff;
      cursor: pointer;
    }

    .register3 {
      position: absolute;
      top: 7.5rem;
      margin-left: 4.6rem;
      display: block;
      height: 0.6rem;
      line-height: 0.6rem;
      border-bottom: 1px solid #fff;
      font-size: 0.24rem;
      color: #fff;
      cursor: pointer;
    }

    .register4 {
      position: absolute;
      top: 5rem;
      margin-left: 3.8rem;
      display: block;
      height: 0.6rem;
      line-height: 0.6rem;
      border-bottom: 1px solid #fff;
      font-size: 0.24rem;
      color: #fff;
      cursor: pointer;
    }
  }
}

.one {
  width: 100%;

  .title1 {
    margin-top: 1.25rem;
  }

  .cont {
    width: 10rem;
    margin: 0 auto;
    margin-top: 0.5rem;
    text-align: center;
    font-size: 0.16rem;
    color: #505050;
    line-height: 0.26rem;
    font-weight: 400;
  }

  ul {
    display: flex;
    margin-top: 0.45rem;

    li {
      flex: 1;
      width: 5.9rem;
      height: 4rem;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      p {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: rgba($color: #000000, $alpha: 0.5);
        font-size: 0.24rem;
        color: #fff;
      }
    }
  }
}

.two {
  width: 100%;

  .title1 {
    margin-top: 1.65rem;
  }

  .chao {
    width: 64%;
    margin-top: 0.75rem;
    margin-left: 19%;

    img {
      width: 6.5rem;
      height: 4rem;
      display: block;
      float: left;
    }

    .cont {
      width: 4.9rem;
      height: 2rem;
      color: #505050;
      font-size: 0.16rem;
      float: left;
      margin-left: 0.6rem;
      line-height: 0.26rem;
      font-weight: 400;
      margin-top: 1rem;
    }
  }
}

.three {
  width: 100%;
  // margin-bottom: 1.9rem;

  .title1 {
    margin-top: 1.7rem;
  }

  .cont {
    width: 9rem;
    height: 1.2rem;
    margin: 0 auto;
    margin-top: 0.55rem;
    color: #505050;
    font-size: 0.16rem;
    line-height: 0.26rem;
    font-weight: 400;
  }

  img {
    width: 100%;
    height: 9.6rem;
    display: block;
    margin-top: 0.45rem;
  }
}

.four {
  width: 100%;

  .title1 {
    margin-top: 1.9rem;
  }

  .choiceImg {
    width: 100%;
    height: 3.6rem;
    margin-top: 0.8rem;

    img {
      width: 5.9rem;
      height: 3.6rem;
      display: block;
      float: left;
    }

    .cont {
      width: 5.6rem;
      padding-left: 0.36rem;
      padding-right: 1.44rem;
      margin-top: 0.2rem;

      box-sizing: border-box h3 {
        font-weight: bold;
        font-size: 0.16rem;
        line-height: 1;
        color: #333;
      }

      .border {
        height: 0.02rem;
        width: 0.22rem;
        background: #000000;
        display: block;
        margin-top: 0.2rem;
      }

      p {
        width: 100%;
        margin-top: 0.4rem;
        color: #505050;
        font-size: 0.16rem;
        line-height: 0.26rem;
        font-weight: 400;
      }

      .btns {
        width: 1.2rem;
        height: 0.36rem;
        background: #000;
        display: block;
        margin-top: 0.36rem;
        color: #fff;
        font-size: 0.14rem;
        line-height: 0.36rem;
        text-align: center;
        cursor: pointer;
      }
    }

    .cont1 {
      padding-left: 0 !important;
    }
  }
}

.five {
  width: 100%;

  .title1 {
    margin-top: 2.1rem;
  }

  ul {
    width: 100%;
    display: flex;
    height: 6rem;
    margin-top: 0.7rem;

    li {
      flex: 1;
      height: 100%;
      background-size: 100% 100%;
      color: #fff;

      h3 {
        width: 100%;
        font-size: 0.24rem;
        line-height: 1;
        text-align: center;
        margin-top: 2.4rem;
      }

      p {
        width: 100%;
        text-align: center;
        font-size: 0.16rem;
        line-height: 1;
        margin-top: 0.2rem;
      }

      span {
        display: block;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 1px solid #fff;
        color: #fff;
        text-align: center;
        line-height: 0.36rem;
        font-size: 0.14rem;
        width: 1.22rem;
        cursor: pointer;
        height: 0.36rem;
      }
    }

    .Imga {
      background: url("../assets/img/add-a.png") no-repeat;
      background-size: cover;
    }

    .Imgb {
      background: url("../assets/img/add-b.png") no-repeat;
      background-size: cover;
    }
  }
}

.six {
  width: 100%;
  padding-bottom: 1.6rem;

  .title1 {
    margin-top: 1.45rem;
  }

  .cont {
    width: 5.4rem;
    margin: 0 auto;
    margin-top: 0.55rem;
    text-align: center;
    font-size: 0.16rem;
    color: #505050;

    p {
      width: 100%;
    }
  }
}

.seven {
  width: 100%;

  .title1 {
    // margin-top: 1.6rem;
  }

  .Img {
    width: 62%;
    margin-top: 0.8rem;
    margin-left: 19%;
    height: 4rem;

    img {
      float: left;
      display: block;
    }

    .a {
      width: 5.7rem;
      height: 100%;
    }

    .b {
      width: 5.5rem;
      height: 4rem;
      margin-left: 0.5rem;
      // margin-top: 0.6rem;
    }
  }
}

.engin {
  margin-top: 1.3rem;
  width: 100%;
  background-color: #30343d;
  .hor:hover {
    cursor: pointer;
  }
  .btn_bom {
    background-color: #292d32;
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    p {
      font-size: 0.14rem;
      color: #75787f;
      text-align: center;
    }
  }
  .contant {
    width: 14rem;
    .text_box {
      float: left;
      margin-left: 1.1rem;
      color: #75787f;
      font-weight: bold;
      letter-spacing: 0.02rem;
      .photo_box {
        margin-top: 0.3rem;
        .photo {
          margin-left: 0.3rem;
        }
        .ph_iocn {
          margin-top: 0.2rem;
        }
        .iocn {
          margin-left: 0.05rem;
        }
        .photo_one {
          margin-left: 0;
        }
        .ph_tit {
          text-align: center;
        }
        .ph_tit2 {
          text-align: left;
          padding-left: 0.15rem;
        }
      }
      .title {
        margin: 0.2rem 0 0.4rem;
        font-size: 0.15rem;
        color: #fdfeff;
      }
      .text {
        margin-top: 0.16rem;
        font-size: 0.13rem;
      }
    }
    .right_text {
      margin-left: 0;
      hr {
        border-color: #75787f;
      }
    }
  }
  .foots {
    padding: 0.5rem 0;
    .btn_mod {
      float: left;
      width: 7rem;
    }
  }
}

.title {
  width: 100%;

  h3 {
    text-align: center;
    width: 100%;
    height: 0.5rem;
    font-size: 0.24rem;
    line-height: 0.5rem;
    color: #333;
    font-weight: 500;
    cursor: pointer;
  }

  span {
    width: 0.22rem;
    height: 1px;
    background: #000;
    display: block;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index1.vue